import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import CurrencySwitcher from './CurrencySwitcher';
import { useAuth } from '../context/AuthContext';
import './StoreHeader.css';

// Mağaza (açık tema) için üst bar. Koyu temalı global Header'dan ayrıdır;
// ana sayfa ve katalog ekranları bunu kullanır.
const StoreHeader = () => {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  const logo = process.env.PUBLIC_URL + '/logo.jpg';

  return (
    <header className="store-header">
      <div className="store-header-inner">
        <Link to="/" className="store-logo">
          <img src={logo} alt="Utkan eSIM" />
          <span>Utkan eSIM</span>
        </Link>

        <div className="store-header-actions">
          <CurrencySwitcher />
          <div className="store-lang">
            <LanguageSwitcher />
          </div>

          {isAuthenticated ? (
            <>
              <Link to="/account" className="store-account">
                <FontAwesomeIcon icon={faUser} />
                <span>{t('nav.account')}</span>
              </Link>
              <button type="button" className="store-logout" onClick={logout}>
                {t('nav.logout')}
              </button>
            </>
          ) : (
            <Link to="/login" className="store-login-btn">
              <FontAwesomeIcon icon={faRightToBracket} />
              <span>{t('nav.login')}</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default StoreHeader;
